/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.navbar' ).toggleClass( 'is-white' );
        $( 'body' ).toggleClass( 'is-locked' );
      } );

      if ( !sessionStorage.getItem( 'kcoa_alert_banner_dismissed', 'true' ) ) {
        $( '.navbar .alert-banner' ).show();
      }

      $( '.navbar .alert-banner .close-alert' ).click( function() {
        $( '.navbar .alert-banner' ).hide();
        sessionStorage.setItem( 'kcoa_alert_banner_dismissed', 'true' );
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      document.addEventListener( 'DOMContentLoaded', function() {
        const lazyBackgrounds = [].slice.call( document.querySelectorAll( '.post-thumbnail-image' ) );

        if ( 'IntersectionObserver' in window ) {
          const lazyBackgroundObserver = new IntersectionObserver( function( entries, observer ) {
            entries.forEach( function( entry ) {
              if ( entry.isIntersecting ) {
                entry.target.classList.add( 'visible' );
                lazyBackgroundObserver.unobserve( entry.target );
              }
            } );
          } );

          lazyBackgrounds.forEach( function( lazyBackground ) {
            lazyBackgroundObserver.observe( lazyBackground );
          } );
        }
      } );

      if ( $( document ).scrollTop() > 1 ) {
        $( '.navbar' ).removeClass( 'is-forced-blur' );
      }

      $( document ).scroll( function() {
        if ( $( '.main > *:first-child' ).hasClass( 'hero-banner' ) ) {
          const el = $( '.navbar' );
          const top = $( document ).scrollTop();
          if ( top > 1 && el.is( '.is-forced-blur' ) ) {
            $( el ).removeClass( 'is-forced-blur' );
          } else if ( top <= 1 ) {
            $( el ).addClass( 'is-forced-blur' );
          }
        }
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      if ( localStorage.getItem( 'kcoaCurrentLocation' ) ) {
        $( '.navbar .nav-location[data-location="' + localStorage.getItem( 'kcoaCurrentLocation' ) + '"]' ).addClass( 'current-location' );
        $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'll_get_current_location',
              params: {
                location: localStorage.getItem( 'kcoaCurrentLocation' ),
              },
            },
            function( data, textStatus, xhr ) {
              data = $.parseJSON( data );
              if ( data.status === 'success' ) {
                $( '.navbar .selected-location .inner-selected-location' ).html( data.response.template );
              }
            }
        );
        let locationName;
        if ( localStorage.getItem( 'kcoaCurrentLocationName' ) ) {
          locationName = localStorage.getItem( 'kcoaCurrentLocationName' );
        } else {
          locationName = 'Find a Location';
        }
        $( '.location-search-toggle span' ).text( locationName );
      } else {
        // $( '.navbar .selected-location button' ).trigger( 'click' );
        $( '.navbar .selected-location, .navbar .find-a-location' ).addClass( 'is-searching' );
      }

      /*
       * LOADING
       */

      $( '.loading-screen' ).addClass( 'is-playing' );

      setTimeout( function() {
        $( '.loading-screen' ).addClass( 'is-loading' );
      }, 5000 );

      setTimeout( function() {
        $( '.loading-screen' ).addClass( 'is-loaded' );
      }, 6000 );

      /*
       * CURRENT LOCATION
       */

      $( document ).on( 'click', '.navbar .nav-location .select-location', function() {
        $( '.navbar .nav-location' ).removeClass( 'current-location' );
        $( '.navbar .nav-location .nearest' ).removeClass( 'force-show' );
        $( '.navbar .nav-location .select-location' ).not( this ).show();
        $( this ).hide();
        $( this ).closest( '.nav-location' ).addClass( 'current-location' );
        const location = $( this ).closest( '.nav-location' ).clone();
        $( '.location-search-toggle span' ).text( $( this ).closest( '.nav-location' ).attr( 'data-name' ) );
        $( this ).closest( '.nav-location' ).remove();
        $( '.navbar .locations-list' ).prepend( location );
        localStorage.setItem( 'kcoaCurrentLocation', $( this ).attr( 'data-location' ) );
        localStorage.setItem( 'kcoaCurrentLocationName', $( this ).closest( '.nav-location' ).attr( 'data-name' ) );
        $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'll_get_current_location',
              params: {
                location: localStorage.getItem( 'kcoaCurrentLocation' ),
              },
            },
            function( data, textStatus, xhr ) {
              data = $.parseJSON( data );
              if ( data.status === 'success' ) {
                $( '.navbar .selected-location .inner-selected-location' ).html( data.response.template );
                $( '.navbar .selected-location, .navbar .find-a-location' ).removeClass( 'is-searching' );
              }
            }
        );
      } );

      if ( $( '.gform_wrapper' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
          if ( $( '#input_' + formId + '_' + fieldId ).val() ) {
            const path = $( '#input_' + formId + '_' + fieldId ).val().replace( 'C:\\fakepath\\', '' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( path );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).addClass( 'has-file' );
          } else {
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( 'No file selected' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).removeClass( 'has-file' );
          }
        }, 10, 3 );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
